import { EB_EVENT_EKLE } from "../constants/requestUrls";
import {  postRequest } from "../request";

const ebEventEkle = (props) => {

    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);

    return postRequest({url:EB_EVENT_EKLE,data});
}

export default ebEventEkle;